import React from 'react';
import { fetchFixedAttributeDisplayNames } from '../../hooks/useFixedAttributeDisplayNames';
import BasePage from '../base';
import { css, StyleSheet } from 'aphrodite';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import ReconnectingWebSocket from 'reconnecting-websocket';
import { convertPxToRem, getValueFromObjectByKeys, translate } from '../../helper';
import TextBase from '../../common/text';
import { Colors } from '../../themes/Colors';
import { connect } from 'react-redux';
import withNavigate from '../../component/WithNavigate';
import { Dropdown, Row, Table, Pagination, DatePicker } from 'antd';
import {
  Box,
  Button,
  IconButton,
  ClickAwayListener,
  Grow,
  MenuItem,
  MenuList,
  Paper,
  Popper,
  Typography,
  styled
} from '@mui/material';
import CheckIcon from '@mui/icons-material/Check';
import Search from '../../common/search';
import { ROUTER_NAME } from '../../router/routers';
import APIManager from '../../connection/ApiManager';
import { quotesStatus } from '../../defined';
import FilterListIcon from '@mui/icons-material/FilterList';
import { size } from 'lodash';
import moment from 'moment';
import { UserAction } from '../../redux/action';
import Utils from '../../utils';
import { getSessionFilter, setSessionFilter } from '../../utils/CommonFunction';
import LocalStorage from '../../defined/localStorage';
import { Link } from 'react-router-dom';
import { exportFile } from '../../utils/exportFile';
import ExportButton from '../../common/export-button';
import { ArrowDropDownIcon } from '@mui/x-date-pickers';
import dayjs from 'dayjs';
import CustomSpinner from '../../common/CustomSpinner';
import PictureAsPdfIcon from '@mui/icons-material/PictureAsPdf';
import TableChartIcon from '@mui/icons-material/TableChart';
import ArticleIcon from '@mui/icons-material/Article';
import CreditCardIcon from '@mui/icons-material/CreditCard';
import ReceiptLongIcon from '@mui/icons-material/ReceiptLong';
import PageTitleHeader from '../../common/page-title-header';

const brandColor = '#F8B218';

const tabContainerStyle = {
  borderRadius: 'calc(var(--sp-md2)*1.50943)',
  boxShadow: '0 4px 20px rgba(248, 178, 24, 0.08)',
  position: 'relative',
  overflow: 'visible !important',
  width: 'fit-content',
  gap: 'var(--sp-md2)',
  display: 'flex',
  marginBottom: 'var(--sp-lg)'
};

const tabStyle = (index, value) => ({
  fontSize: 'calc(var(--fs-xs)*1.4150943)',
  fontWeight: value === index ? 600 : 500,
  textTransform: 'none',
  color: value === index ? '#FFFFFF' : '#6B7280',
  backgroundColor: value === index ? brandColor : '#ECECEC',
  borderRadius: 'calc(var(--sp-md2)*1.132075)',
  padding: 'var(--sp-md2) calc(var(--sp-md2)*1.698113)',
  minHeight: 'calc(var(--fs-hero)*1.226415)',
  position: 'relative',
  maxWidth: 'fit-content',
  overflow: 'visible',
  boxShadow:
    value === index ? '0 6px 16px rgba(248, 178, 24, 0.25)' : '0 1px 4px rgba(0, 0, 0, 0.05)',
  transition: 'all 0.25s ease',
  border: 'none',
  '&.Mui-selected': {
    color: '#FFFFFF',
    backgroundColor: brandColor
  },
  '&:hover': {
    backgroundColor: value !== index ? '#E5E7EB' : brandColor,
    transform: 'translateY(-1px)'
  },
  '&::after': {
    content: '""',
    position: 'absolute',
    bottom: 'calc(var(--sp-xxs)*-2)',
    left: '50%',
    transform: 'translateX(-50%)',
    borderLeft: 'var(--sp-md2) solid transparent',
    borderRight: 'var(--sp-md2) solid transparent',
    borderTop: value === index ? `var(--sp-md2) solid ${brandColor}` : 'none'
  }
});

const QuotesBox = styled('div')(({ theme }) => ({
  backgroundColor: '#ffffff',
  backgroundImage: 'linear-gradient(135deg, #fff 0%, #fff 100%)',
  overflowY: 'auto',
  padding: 'calc(var(--sp-lg)*1.5) calc(var(--sp-lg)*1.6) calc(var(--sp-md2)*1)',
  '& .ant-table-container': {
    overflowX: 'auto',
    scrollbarWidth: 'none',
    msOverflowStyle: 'none',
    '&::-webkit-scrollbar': {
      display: 'none'
    }
  },
  '& .ant-table': {
    backgroundColor: '#ffffff',
    borderRadius: '16px',
    overflow: 'hidden',
    boxShadow: '0 10px 40px rgba(0, 0, 0, 0.08), 0 2px 8px rgba(0, 0, 0, 0.04)',
    transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
    border: '1px solid rgba(229, 231, 235, 0.6)',
    borderCollapse: 'collapse',
    '&:hover': {
      boxShadow: '0 12px 48px rgba(0, 0, 0, 0.1), 0 2px 8px rgba(0, 0, 0, 0.04)'
    }
  },
  '& .ant-table-thead > tr': {
    backgroundColor: 'linear-gradient(135deg, #1A5A78 0%, #0F3D52 100%)',
    borderRight: 'none !important',
    borderLeft: 'none !important',
    borderTop: 'none !important'
  },
  '& .ant-table-thead > tr > th': {
    backgroundColor: '#1A5A78 !important',
    color: '#ffffff !important',
    borderBottom: '2px solid #0F3D52 !important',
    borderRight: 'none !important',
    borderLeft: 'none !important',
    borderTop: 'none !important',
    transition: 'all 0.3s ease',
    letterSpacing: '0.035em',
    boxShadow: 'inset 0 1px 2px rgba(255, 255, 255, 0.3), inset 0 -1px 0 rgba(0, 0, 0, 0.1)',
    whiteSpace: 'nowrap'
  },
  '& .ant-table-tbody > tr': {
    position: 'relative',
    transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
    borderBottom: '1px solid rgba(229, 231, 235, 0.7) !important',
    backgroundColor: '#ffffff',
    '&:hover': {
      backgroundColor:
        'linear-gradient(90deg, rgba(26, 90, 120, 0.06) 0%, rgba(26, 90, 120, 0.02) 100%) !important',
      boxShadow: `
      0 12px 28px rgba(15, 23, 42, 0.10),
      0 2px 8px rgba(15, 23, 42, 0.06)
    `,
      zIndex: 2,

      background:
        'linear-gradient(90deg, rgba(26,90,120,0.04) 0%, rgba(255,255,255,1) 50%, rgba(26,90,120,0.04) 100%)',
      transform: 'translateY(-2px) scale(1.004)'
    },
    '&:last-child': {
      borderBottom: 'none !important'
    }
  },
  '& .ant-table tbody tr': {
    border: 'none !important'
  },
  '& .ant-table-tbody > tr > td': {
    color: '#1f2937',
    transition: 'all 0.2s ease',
    borderBottom: '1px solid rgba(229, 231, 235, 0.8) !important',
    borderRight: 'none !important',
    borderLeft: 'none !important',
    borderTop: 'none !important',
    backgroundColor: '#ffffff'
  },
  '& .ant-table-tbody > tr:last-child > td': {
    borderBottom: 'none !important'
  },
  '& .ant-table-tbody > tr:hover > td': {
    backgroundColor: 'rgba(26, 90, 120, 0.03) !important',
    borderTop: '1px solid rgba(26,90,120,0.08)',
    borderBottom: '1px solid rgba(26,90,120,0.08)'
  },
  '& .MuiOutlinedInput-input': {
    padding: 'var(--sp-md2) calc(var(--sp-md2)*1.4)'
  },
  '& .MuiButton-root': {
    backgroundColor: '#ffffff !important',
    color: '#374151 !important',
    border: '1.5px solid #e5e7eb !important',
    borderRadius: 'var(--sp-md2)',
    fontWeight: '500',
    transition: 'all 0.25s cubic-bezier(0.4, 0, 0.2, 1)',
    boxShadow: '0 2px 4px rgba(0, 0, 0, 0.04)',
    fontSize: 'calc(var(--fs-xs) * 1.5)',
    '&:hover': {
      backgroundColor: '#f9fafb !important',
      borderColor: '#d1d5db !important',
      boxShadow: '0 8px 20px rgba(0, 0, 0, 0.08)',
      transform: 'translateY(-2px)'
    },
    '&:active': {
      transform: 'translateY(0)'
    }
  },
  '& .MuiButtonGroup-root': {
    boxShadow: '0 2px 4px rgba(0, 0, 0, 0.04) !important',
    height: 'calc(var(--fs-xl)*2.35)',
    borderRadius: 'var(--sp-md2)',
    border: '1.5px solid #e5e7eb !important',
    backgroundColor: '#ffffff',
    transition: 'all 0.2s ease'
  }
}));

const dateTimeFormat = 'MM/DD/YYYY';
const dateTimeFormatServer = 'YYYY-MM-DD';
const styles = StyleSheet.create({
  container: {
    textAlign: 'left',
    whiteSpace: 'pre-line',
    position: 'relative',
    overflowY: 'auto',
    overflowX: 'hidden',
    padding: 'calc(var(--sp-lg)*1.5) calc(var(--sp-lg)*1.6) calc(var(--sp-md2)*1)'
  }
});
const menuKey = {
  legal: 'legal',
  policy: 'policy',
  agreement: 'agreement',
  note: 'note'
};

const ORDER_DELIVERY_STATUS = ['instore', 'delivery'];

class Quotes extends BasePage {
  constructor(props) {
    super(props);
    this.title = 'Accepted Quotes';
    const saved = getSessionFilter('quotes', null);
    const today = dayjs();
    const twoWeekAgo = dayjs().subtract(30, 'day');
    this.state = {
      menuSelected: menuKey.policy,
      quotes: [],
      next: null,
      previous: null,
      page: saved?.page || 1,
      total: 0,
      loading: true,
      visibleDropdownSort: false,
      sortBy: saved?.sortBy || 'desc',
      textSearch: saved?.textSearch || '',
      value: saved?.value || 0,
      limit: saved?.limit || 15,
      start_at: saved?.start_at || twoWeekAgo.format(dateTimeFormatServer),
      end_at: saved?.end_at || today.format(dateTimeFormatServer),
      exportBtnLoading: false,
      selectedRowKeys: [],
      paymentMethod: 'all_order',
      openPaymentFilter: false,
      paymentAnchorEl: null
    };
    this.columns = this.buildColumns();
    this.limit = 50;
    this.sortByAnchorRef = React.createRef();
  }

  PaymentFilterOptions = [
    { label: 'All Order', value: 'all_order' },
    { label: 'Stripe', value: 'stripe' },
    { label: translate('accountBilling'), value: 'account' }
  ];

  buildColumns(displayNames) {
    const names = displayNames || this.state?.fixedAttributeDisplayname || {};
    return [
      {
        title: () => (
          <TextBase size={convertPxToRem('calc(var(--fs-sm2) * 1.015)')} fontWeight={500}>
            acceptedDate
          </TextBase>
        ),
        dataIndex: 'accepted_date',
        key: 'accepted_date',
        render: (value, record, index) => {
          return moment(record?.updated_at, 'YYYY-MM-DD HH:mm:ss').format('MM/DD/YYYY hh:mm');
        }
      },
      {
        title: () => (
          <TextBase size={convertPxToRem('calc(var(--fs-sm2) * 1.015)')} fontWeight={500}>
            customerPo
          </TextBase>
        ),
        dataIndex: 'name',
        key: 'name',
        render: (value, record, index) => {
          return (
            <Link
              style={{
                color: '#517D98',
                textDecoration: 'underline'
              }}
              to={`${ROUTER_NAME.orderDetail}/${record?.order?.id}`}
              onClick={(e) => {
                e.stopPropagation();
              }}>
              {record?.order?.id}
            </Link>
          );
        }
      },
      {
        title: () => (
          <TextBase size={convertPxToRem('calc(var(--fs-sm2) * 1.015)')} fontWeight={500}>
            {names['order_name'] || 'orderName'}
          </TextBase>
        ),
        dataIndex: 'quote',
        key: 'quote',
        render: (value, record, index) => {
          return record?.order?.name;
        }
      },
      {
        title: () => (
          <TextBase size={'calc(var(--fs-sm2) * 1.015)'} fontWeight={500}>
            fulfilledBy
          </TextBase>
        ),
        dataIndex: 'name',
        key: 'name',
        render: (value, record, index) => {
          return record?.profile?.user?.name || 'N/A';
        }
      },
      {
        title: () => (
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
            <span
              style={{
                fontSize: 'calc(var(--fs-sm2) * 1.015)',
                color: this.state.paymentMethod !== 'all_order' ? '#FBBF24' : '#ffffff',
                fontWeight: this.state.paymentMethod !== 'all_order' ? 700 : 600,
                transition: 'all 0.2s ease'
              }}>
              {translate('paymentInfo')}
            </span>
            <IconButton
              size="small"
              title="Filter by payment method"
              aria-label="Filter by payment method"
              onClick={(e) => {
                e.stopPropagation();
                e.preventDefault();
                const r = e.currentTarget.getBoundingClientRect();
                const virtualAnchor = {
                  getBoundingClientRect: () => ({
                    width: 0,
                    height: 0,
                    x: r.left + r.width / 2,
                    y: r.bottom + 4,
                    top: r.bottom + 4,
                    left: r.left + r.width / 2,
                    right: r.left + r.width / 2,
                    bottom: r.bottom + 4
                  })
                };
                this.setState({
                  paymentAnchorEl: virtualAnchor,
                  openPaymentFilter: !this.state.openPaymentFilter
                });
              }}
              sx={{
                p: 'calc(var(--sp-xxs)*.471698)',
                position: 'relative',
                borderRadius: '999px',
                backgroundColor:
                  this.state.paymentMethod !== 'all_order'
                    ? 'rgba(251, 191, 36, 0.18)'
                    : 'transparent',

                '&:hover': {
                  backgroundColor:
                    this.state.paymentMethod !== 'all_order'
                      ? 'rgba(251, 191, 36, 0.25)'
                      : 'rgba(255,255,255,0.12)'
                }
              }}>
              <FilterListIcon
                sx={{
                  fontSize: 'calc(var(--fs-xs) * 1.698113)',
                  color: this.state.paymentMethod !== 'all_order' ? '#FBBF24' : '#ffffff',
                  transition: 'all 0.2s ease'
                }}
              />
              {this.state.paymentMethod !== 'all_order' && (
                <Box
                  sx={{
                    position: 'absolute',
                    top: 2,
                    right: 2,
                    width: 6,
                    height: 6,
                    borderRadius: '50%',
                    backgroundColor: '#FBBF24',
                    boxShadow: '0 0 0 2px #0B5C7A'
                  }}
                />
              )}
            </IconButton>
          </Box>
        ),
        dataIndex: 'stripe_charge_id',
        key: 'stripe_charge_id',
        render: (value, record) => {
          const isStripe = record?.stripe_charge_id !== 'NS';

          const label = isStripe ? 'Stripe' : 'Account Billing';
          const Icon = isStripe ? CreditCardIcon : ReceiptLongIcon;

          return (
            <Box
              sx={{
                display: 'inline-flex',
                alignItems: 'center',
                letterSpacing: 'calc(var(--sp-xxs)*0.0943396))',
                color: isStripe ? '#1E40AF' : '#6B21A8',
                transition: 'all 0.2s cubic-bezier(0.4, 0, 0.2, 1)',
                backdropFilter: 'blur(2px)',
                cursor: 'default'
              }}>
              <Typography
                component="span"
                sx={{
                  fontSize: 'calc(var(--fs-xs) * 1.6)',
                  color: 'inherit',
                  whiteSpace: 'nowrap',
                  letterSpacing: 'calc(var(--sp-xxs)*0.0943396))'
                }}>
                {label}
              </Typography>
            </Box>
          );
        }
      },
      {
        title: () => (
          <TextBase size={'calc(var(--fs-sm2) * 1.015)'} fontWeight={500}>
            fulfillmentDate
          </TextBase>
        ),
        key: 'order_fullfill_date',
        dataIndex: 'order_fullfill_date',
        render: (value, record, index) => {
          return value ? moment(value, 'YYYY-MM-DD HH:mm:ss').format('MM/DD/YYYY hh:mm') : 'N/A';
        }
      }
    ];
  }
  exportOptions = [
    {
      label: 'CSV',
      value: 'csv',
      icon: <ArticleIcon sx={{ fontSize: 'calc(var(--fs-xs) * 1.698113)' }} />
    },
    {
      label: 'Excel',
      value: 'excel',
      icon: <TableChartIcon sx={{ fontSize: 'calc(var(--fs-xs) * 1.698113)' }} />
    },
    {
      label: 'PDF',
      value: 'pdf',
      icon: <PictureAsPdfIcon sx={{ fontSize: 'calc(var(--fs-xs) * 1.698113)' }} />
    }
  ];
  handleDateRangeChange = (dates) => {
    if (dates) {
      const [startDate, endDate] = dates;
      const updatedStart = dayjs(startDate).format(dateTimeFormatServer);
      const updatedEnd = dayjs(endDate).format(dateTimeFormatServer);
      this.setState({ start_at: updatedStart, end_at: updatedEnd, page: 1 }, () => {
        setSessionFilter('quotes', {
          page: 1,
          limit: this.state.limit,
          sortBy: this.state.sortBy,
          textSearch: this.state.textSearch,
          value: this.state.value,
          start_at: this.state.start_at,
          end_at: this.state.end_at
        });
        this.getData(1);
      });
    } else {
      this.setState({ start_at: '', end_at: '', page: 1 }, () => {
        setSessionFilter('quotes', {
          page: 1,
          limit: this.state.limit,
          sortBy: this.state.sortBy,
          textSearch: this.state.textSearch,
          value: this.state.value,
          start_at: this.state.start_at,
          end_at: this.state.end_at
        });
        this.getData(1);
      });
    }
  };
  handleExportSelect = (format) => {
    this.exportQuotes(format);
  };
  exportQuotes = (format) => {
    const { userInfo } = this.props;
    const { user } = userInfo;
    const {
      sortBy,
      textSearch,
      value,
      limit,
      page,
      start_at,
      end_at,
      selectedRowKeys,
      paymentMethod
    } = this.state;
    if (!user?.vendor?.id) return;
    let params = {
      vendor__id: user.vendor.id,
      status: quotesStatus.ACCEPTED,
      ordering: sortBy === undefined ? undefined : sortBy === 'asc' ? 'created_at' : '-created_at',
      search: textSearch,
      offset: limit * (page - 1),
      limit,
      start_at,
      end_at
    };
    if (value !== 0 && value <= ORDER_DELIVERY_STATUS.length) {
      params.order_delivery_status = ORDER_DELIVERY_STATUS[value - 1];
    } else if (value === ORDER_DELIVERY_STATUS.length + 1) {
      params.warranty = true;
    } else if (value === ORDER_DELIVERY_STATUS.length + 2) {
      params.core = true;
    }
    // Add selected quote IDs if any are selected
    if (selectedRowKeys.length > 0) {
      params.quote_ids = selectedRowKeys;
    }
    if (paymentMethod === 'stripe') params.payment_method = '1';
    if (paymentMethod === 'account') params.payment_method = '2';
    Object.keys(params).forEach(
      (key) => (params[key] == null || params[key] === '') && delete params[key]
    );
    this.setState({ exportBtnLoading: true });
    exportFile({
      endpoint: 'quotes/export/',
      params,
      format,
      filenameBase: 'quotes',
      setLoading: (exportBtnLoading) => this.setState({ exportBtnLoading })
    });
  };

  onSelectChange = (newSelectedRowKeys) => {
    this.setState({ selectedRowKeys: newSelectedRowKeys });
  };

  handlePaymentFilterSelect = (val) => {
    this.setState({ paymentMethod: val, openPaymentFilter: false, paymentAnchorEl: null }, () =>
      this.getData(1)
    );
  };

  componentDidMount() {
    super.componentDidMount();
    this.getUpdates();
    this.getData();
    this.getFixedAttributeDisplayNames();
  }

  getFixedAttributeDisplayNames = async () => {
    try {
      const names = await fetchFixedAttributeDisplayNames();
      this.setState({ fixedAttributeDisplayname: names }, () => {
        this.columns = this.buildColumns(names);
        this.forceUpdate();
      });
    } catch (e) {}
  };

  onSearch = () => {
    this.getData(0);
  };

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (nextProps?.vendor?.id !== this.props?.vendor?.id) {
      this.getData(0, nextProps);
    }
  }

  getData = async (page = this.state.page, props = this.props, value = this.state.value) => {
    try {
      const { sortBy, textSearch, paymentMethod } = this.state;
      const { userInfo } = props;
      const { user } = userInfo;
      if (!user?.vendor?.id) {
        this.setState({
          loading: false
        });
        return;
      }
      this.setState({ loading: true });
      let query = {
        offset: this.state.limit * (page - 1),
        limit: this.state.limit,
        vendor__id: user?.vendor?.id,
        status: quotesStatus.ACCEPTED,
        ordering:
          sortBy === undefined ? undefined : sortBy === 'asc' ? `created_at` : '-created_at',
        start_at: this.state.start_at,
        end_at: this.state.end_at
      };
      if (paymentMethod === 'stripe') query.payment_method = '1';
      if (paymentMethod === 'account') query.payment_method = '2';

      if (value !== 0 && value <= ORDER_DELIVERY_STATUS.length) {
        query.order_delivery_status = ORDER_DELIVERY_STATUS[value - 1];
      } else if (value === ORDER_DELIVERY_STATUS.length + 1) {
        query.warranty = true;
      } else if (value === ORDER_DELIVERY_STATUS.length + 2) {
        query.core = true;
      }

      if (textSearch) {
        query.search = textSearch;
      }
      const resOrder = await APIManager.getInstance().getQuotes(query);
      const results = resOrder?.data?.results || [];
      const total = resOrder?.data?.count;
      const next = resOrder?.data?.next;
      const previous = resOrder?.data?.previous;
      const newPage = page || 1;
      this.setState(
        {
          quotes: results,
          total,
          next,
          previous,
          page: newPage,
          loading: false
        },
        () => {
          setSessionFilter('quotes', {
            page: newPage,
            limit: this.state.limit,
            sortBy: sortBy,
            textSearch: textSearch,
            value: value,
            start_at: this.state.start_at,
            end_at: this.state.end_at
          });
        }
      );
    } catch (error) {
      this.setState({ loading: false });
      Utils.showAlert(2, error.detail || error.message);
    }
  };
  nextData = () => {
    const { next } = this.state;
    if (!next) return;
    this.getData(this.state.page + 1);
  };
  previousData = () => {
    const { previous } = this.state;
    if (!previous) return;
    this.getData(this.state.page - 1);
  };
  onClickItemQuote = async (record) => {
    try {
      const quoteId = record?.id;
      const resUserQuote = await APIManager.getInstance().getUserQuotes({
        quote__id: quoteId
      });
      const results = resUserQuote?.data?.results;
      if (results && size(results)) {
        const itemFirst = results[0];
        if (itemFirst?.user) {
          const resOrder = await APIManager.getInstance().getOrders({
            vendors__id: record?.vendor?.id,
            user__id: itemFirst?.user
          });
          const resultsOrder = resOrder?.data?.results;
          const orderWithQuote = resultsOrder.filter((x) =>
            x?.quotes.find((y) => `${y?.id}` === `${quoteId}`)
          );
          if (orderWithQuote && size(orderWithQuote)) {
            this.props.navigate(`${ROUTER_NAME.orderDetail}?id=${orderWithQuote[0]?.id}`);
          }
        }
      }
    } catch (error) {}
  };

  getUpdates = () => {
    const { userInfo } = this.props;

    this.socket = new ReconnectingWebSocket(
      `wss://${Utils.constants.API_URL?.replace('https://', '')}ws/orders/?token=${userInfo?.token}`
    );

    this.socket.onmessage = (event) => {
      if (window.location.pathname.includes('quotes')) {
        const data = JSON.parse(event.data);
        this.getData(0);
        this.props.getNotifications();
      }
    };
  };

  tabProps = (index) => {
    return {
      id: `simple-tab-${index}`,
      'aria-controls': `simple-tabpanel-${index}`
    };
  };

  handleChange = async (event, newValue) => {
    this.setState({ value: newValue, page: 1, textSearch: '', selectedRowKeys: [] });
    await this.getData(1, this.props, newValue);
  };

  renderContent() {
    const { textSearch, quotes, loading, visibleDropdownSort, sortBy, value } = this.state;
    const tabs = [
      { label: 'all', index: 0 },
      { label: 'inStorePickup', index: 1 },
      { label: 'delivery', index: 2 },
      { label: 'warranty', index: 3 },
      { label: 'core', index: 4 }
    ];
    return (
      <QuotesBox>
        <PageTitleHeader
          title={translate('acceptedQuotes')}
          containerStyle={{ marginBottom: 'var(--sp-lg)' }}
        />
        <Tabs
          value={value}
          onChange={this.handleChange}
          aria-label="tabs"
          sx={{
            overflow: 'visible',
            '& .MuiTabs-scroller': { overflow: 'visible !important' },
            '& .MuiTabs-flexContainer': tabContainerStyle
          }}
          TabIndicatorProps={{
            sx: {
              display: 'none'
            }
          }}>
          {tabs.map((tab) => (
            <Tab
              key={tab.index}
              sx={tabStyle(tab.index, value)}
              label={translate(tab.label)}
              {...this.tabProps(tab.index)}
            />
          ))}
        </Tabs>
        <Row>
          <div
            className="flex-row-center-between width-100"
            style={{ gap: 'calc(var(--sp-md2)*1.5)' }}>
            <Search
              placeholder={translate('searchQuotes')}
              tooltip="Search by PO#, order name or fulfilled by."
              value={textSearch}
              setQuery={(text) => {
                this.setState(
                  {
                    textSearch: text
                  },
                  () => this.onSearch()
                );
              }}
              sx={{
                width: 'calc(var(--fs-hero)*8.254)',
                '& .MuiOutlinedInput-input': {
                  fontSize: 'var(--fs-md2) !important',
                  padding: 'var(--sp-md2) var(--sp-md2*1.4)'
                },
                '& .MuiOutlinedInput-input::placeholder': {
                  fontSize: 'var(--fs-md2)',
                  padding: 'var(--sp-md2) var(--sp-md2*1.4)',
                  lineHeight: '100%'
                }
              }}
            />
            <div className="flex-row-center" style={{ gap: 'calc(var(--sp-md2)*1.5)' }}>
              <DatePicker.RangePicker
                popupClassName="responsive-datepicker-dropdown"
                allowClear={false}
                style={{
                  width: 'calc(var(--fs-hero)*6.132075)',
                  height: 'calc(var(--fs-xl)*2.35) !important',
                  borderRadius: 'calc(var(--sp-xxs)*2)',
                  padding: 'calc(var(--sp-md)*1) calc(var(--sp-md)*1)'
                }}
                format={dateTimeFormat}
                for
                disabledDate={(current) => {
                  return false;
                }}
                value={[
                  this.state.start_at ? dayjs(this.state.start_at) : null,
                  this.state.end_at ? dayjs(this.state.end_at) : null
                ]}
                defaultValue={undefined}
                onChange={this.handleDateRangeChange}
                onOk={(value) => {}}
              />
              <ExportButton
                options={this.exportOptions}
                onExport={this.handleExportSelect}
                loading={this.state.exportBtnLoading}
                buttonProps={{
                  sx: {
                    textTransform: 'capitalize',
                    boxShadow: 'none',
                    fontWeight: 400,
                    minWidth: 'calc(var(--fs-hero)*3.537)',
                    height: 'calc(var(--fs-xl)*2.35) !important',
                    maxWidth: 'calc(var(--fs-hero)*4.245)',
                    whiteSpace: 'nowrap',
                    overflow: 'hidden',
                    textOverflow: 'ellipsis',
                    backgroundColor: 'white !important',
                    borderRadius: 'calc(var(--sp-xxs)*2)',
                    color: 'black',
                    border: '1px solid #C8C8C8 !important',
                    fontSize: 'calc(var(--fs-sm2) * 1.015)',
                    '& .MuiSvgIcon-root': {
                      height: 'var(--fs-xl)',
                      width: 'var(--fs-xl)'
                    }
                  }
                }}
              />
              <Box
                ref={this.sortByAnchorRef}
                sx={{
                  display: 'flex',
                  alignItems: 'center',
                  position: 'relative'
                }}>
                <Button
                  onClick={() =>
                    this.setState({
                      visibleDropdownSort: !visibleDropdownSort
                    })
                  }
                  sx={{
                    textTransform: 'capitalize',
                    fontWeight: 700,
                    height: 'calc(var(--fs-xl)*2.35) !important',
                    whiteSpace: 'nowrap',
                    overflow: 'hidden',
                    textOverflow: 'ellipsis',
                    borderRadius: 'var(--sp-md2)',
                    fontSize: 'calc(var(--fs-sm2) * 1.015)',
                    backgroundColor: '#ffffff !important',
                    border: '1.5px solid #e5e7eb !important',
                    color: '#374151 !important',
                    boxShadow:
                      '0 4px 6px rgba(0, 0, 0, 0.07), inset 0 1px 0 rgba(255, 255, 255, 0.5)',
                    transition: 'all 0.2s cubic-bezier(0.4, 0, 0.2, 1)',
                    position: 'relative',
                    padding: 'calc(var(--sp-md)*1) calc(var(--sp-md2)*1.3)',
                    display: 'flex',
                    alignItems: 'center',
                    gap: 'calc(var(--sp-xxs)*1.5)',
                    '&:hover': {
                      backgroundColor: '#f3f4f6 !important',
                      borderColor: '#d1d5db !important',
                      boxShadow:
                        '0 12px 24px rgba(0, 0, 0, 0.12), inset 0 1px 0 rgba(255, 255, 255, 0.6)',
                      transform: 'translateY(-2px)'
                    },
                    '&:active': {
                      transform: 'translateY(-1px)',
                      boxShadow: '0 4px 8px rgba(0, 0, 0, 0.08)'
                    }
                  }}>
                  <span style={{ fontWeight: 500, color: '#374151' }}>{translate('sortBy')}</span>
                  <span style={{ fontWeight: 600, color: '#1A5A78' }}>
                    {sortBy === 'desc' ? translate('newestToOldest') : translate('oldestToNewest')}
                  </span>
                  <ArrowDropDownIcon
                    sx={{
                      fontSize: 'calc(var(--fs-xl) * 1.132075)',
                      marginLeft: 'auto',
                      transition: 'transform 0.2s ease',
                      transform: visibleDropdownSort ? 'rotate(180deg)' : 'rotate(0deg)',
                      color: '#9ca3af'
                    }}
                  />
                </Button>
                <Popper
                  sx={{
                    zIndex: 9999,
                    textTransform: 'capitalize'
                  }}
                  open={visibleDropdownSort}
                  anchorEl={this.sortByAnchorRef.current}
                  placement="bottom-start"
                  strategy="fixed"
                  role={undefined}
                  transition
                  disablePortal
                  modifiers={[
                    {
                      name: 'sameWidth',
                      enabled: true,
                      phase: 'beforeWrite',
                      requires: ['computeStyles'],
                      fn: ({ state }) => {
                        state.styles.popper.width = `${state.rects.reference.width}px`;
                      }
                    },
                    {
                      name: 'preventOverflow',
                      options: {
                        altBoundary: true,
                        tether: false,
                        padding: 8
                      }
                    },
                    {
                      name: 'offset',
                      options: {
                        offset: [0, 4]
                      }
                    }
                  ]}>
                  {({ TransitionProps, placement }) => (
                    <Grow
                      {...TransitionProps}
                      style={{
                        transformOrigin: placement === 'bottom' ? 'center top' : 'center bottom'
                      }}>
                      <Paper sx={{ width: '100%' }}>
                        <ClickAwayListener
                          onClickAway={() =>
                            this.setState({
                              visibleDropdownSort: false
                            })
                          }>
                          <MenuList autoFocusItem>
                            <MenuItem
                              selected={sortBy === 'desc'}
                              onClick={() => {
                                this.setState(
                                  {
                                    sortBy: 'desc',
                                    visibleDropdownSort: false,
                                    page: 1
                                  },
                                  () => {
                                    this.getData(1);
                                  }
                                );
                              }}
                              style={{
                                color: sortBy === 'desc' ? '#1A5A78' : '#000',
                                fontSize: 'var(--fs-md2)',
                                fontWeight: sortBy === 'desc' ? '600' : '500'
                              }}>
                              {translate('newestToOldest')}
                            </MenuItem>
                            <MenuItem
                              selected={sortBy === 'asc'}
                              onClick={() => {
                                this.setState(
                                  {
                                    sortBy: 'asc',
                                    visibleDropdownSort: false,
                                    page: 1
                                  },
                                  () => {
                                    this.getData(1);
                                  }
                                );
                              }}
                              style={{
                                color: sortBy === 'asc' ? '#1A5A78' : '#000',
                                fontSize: 'var(--fs-md2)',
                                fontWeight: sortBy === 'asc' ? '600' : '500'
                              }}>
                              {translate('oldestToNewest')}
                            </MenuItem>
                          </MenuList>
                        </ClickAwayListener>
                      </Paper>
                    </Grow>
                  )}
                </Popper>
              </Box>
            </div>
          </div>
        </Row>
        <Row style={{ marginTop: 'calc(var(--fs-xl)*1.6)' }}>
          <Table
            style={{ width: '100%' }}
            columns={this.columns}
            dataSource={quotes}
            rowKey={(record) => record.id}
            total={this.state.total}
            pagination={false}
            className="custom-checkbox"
            rowSelection={{
              selectedRowKeys: this.state.selectedRowKeys,
              onChange: this.onSelectChange
            }}
            components={{
              header: {
                cell: ({ children, ...rest }) => {
                  return (
                    <th
                      {...rest}
                      style={{
                        padding: 'var(--sp-lg)'
                      }}>
                      {children}
                    </th>
                  );
                }
              },
              body: {
                cell: ({ children, ...rest }) => {
                  return (
                    <td
                      {...rest}
                      style={{
                        padding: 'var(--sp-lg)'
                      }}>
                      {children}
                    </td>
                  );
                }
              }
            }}
            onRow={(record) => {
              return {
                onClick: (e) => {
                  this.props.navigate(`${ROUTER_NAME.orderDetail}/${record?.order?.id}`);
                }
              };
            }}
            loading={{ spinning: loading, indicator: <CustomSpinner fullPage /> }}
          />
          {!loading && (
            <div
              style={{
                display: 'flex',
                justifyContent: 'space-between',
                marginTop: 'calc(var(--sp-lg)*0.9433)',
                width: '100%'
              }}>
              <TextBase
                style={{
                  color: '#000'
                }}
                size={'var(--fs-md2)'}>
                {translate('showing')} <b>{(this.state.page - 1) * this.state.limit + 1}</b>{' '}
                {translate('to')}{' '}
                <b>{Math.min(this.state.page * this.state.limit, this.state.total)}</b>{' '}
                {translate('of')} <b>{this.state.total}</b> {translate('results')}
              </TextBase>
              <Pagination
                className="custom-pagination"
                current={this.state.page}
                pageSize={this.state.limit}
                total={this.state.total}
                onChange={(pageNumber) => {
                  if (this.state.loading) return;
                  this.setState({ page: pageNumber }, () => this.getData(pageNumber));
                }}
                showSizeChanger={false}
              />
            </div>
          )}
        </Row>
        <Popper
          sx={{ zIndex: 99999 }}
          open={this.state.openPaymentFilter}
          anchorEl={this.state.paymentAnchorEl}
          placement="bottom"
          strategy="fixed"
          transition
          disablePortal
          modifiers={[
            { name: 'offset', options: { offset: [0, 8] } },
            { name: 'preventOverflow', options: { padding: 8 } }
          ]}>
          {({ TransitionProps, placement }) => (
            <Grow
              {...TransitionProps}
              style={{
                transformOrigin: placement === 'bottom' ? 'center top' : 'center bottom'
              }}>
              <Paper
                sx={{
                  minWidth: 'calc(var(--fs-hero)*4.24528)',
                  boxShadow: '0 4px 12px rgba(0,0,0,0.15)'
                }}>
                <ClickAwayListener
                  onClickAway={() => {
                    this.setState({ openPaymentFilter: false, paymentAnchorEl: null });
                  }}>
                  <MenuList autoFocusItem>
                    {this.PaymentFilterOptions.map((option) => (
                      <MenuItem
                        key={option.value}
                        selected={option.value === this.state.paymentMethod}
                        onClick={() => {
                          this.handlePaymentFilterSelect(option.value);
                        }}
                        sx={{
                          fontSize: 'var(--fs-md2)',
                          display: 'flex',
                          alignItems: 'center',
                          gap: 1
                        }}>
                        <span style={{ flex: 1 }}>{option.label}</span>
                        {option.value === this.state.paymentMethod && (
                          <CheckIcon sx={{ fontSize: 'var(--fs-xl)' }} />
                        )}
                      </MenuItem>
                    ))}
                  </MenuList>
                </ClickAwayListener>
              </Paper>
            </Grow>
          )}
        </Popper>
      </QuotesBox>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    userDetail: getValueFromObjectByKeys(state, ['User', 'userDetail']),
    userInfo: getValueFromObjectByKeys(state, ['User', 'userInfo']),
    listNotification: getValueFromObjectByKeys(state, ['User', 'notification']),
    vendor: getValueFromObjectByKeys(state, ['User', 'vendor']),
    whiteLabel: getValueFromObjectByKeys(state, ['User', 'branding'])
  };
};
const mapDispatchToProps = (dispatch) => {
  return {
    getNotifications: () => {
      return dispatch(UserAction.getNotifications());
    }
  };
};
export default connect(mapStateToProps, mapDispatchToProps)(withNavigate(Quotes));
